module.exports = __webpack_public_path__ + "static/tim-gerend-speaking-publicly.7731d802.webp";